import moment from "moment"
import { getWorkkeysReplaceTerm } from "../../helpers/workkeysReplaceTerms"
import { TableData } from "./types"

export const LICENSE_POOLS: TableData = {
  columns: [], // Already defined in tables.ts HEADER_COLUMNS
  displayedProperties: [
    "org_view_licenses.entityName",
    "org_view_licenses.type",
    "org_view_licenses.content",
    "org_view_licenses.maxLicenses",
    "org_view_licenses.startDate",
    "org_view_licenses.endDate"
  ],
  requestParams: {
    dimensions: [
      "org_view_licenses.id",
      "org_view_licenses.maxLicenses",
      "org_view_licenses.startDate",
      "org_view_licenses.endDate",
      "org_view_licenses.entityId",
      "org_view_licenses.entityType",
      "org_view_licenses.entityName"
    ],
    measures: []
  },
  requestFilterMap: {},
  searchRequestParams: [
    "org_view_licenses.entityName"
  ],
  tableOptions: {
    entityLabel: "License Pool",
    searchPlaceholder: "License Pools",
    caption: "List of License Pool items",
    hideColumnSelector: true,
    isExpandable: true,
    deleteMessageTemplate: record => {
      const maxLicenses =
        record["org_view_licenses.maxLicenses"] || record.poolCount
      // Parse dates as UTC and format without timezone conversion
      const startDate = moment
        .utc(record["org_view_licenses.startDate"] || record.startDate)
        .format("MM/DD/YYYY")
      const endDate = moment
        .utc(record["org_view_licenses.endDate"] || record.endDate)
        .format("MM/DD/YYYY")
      return `You are about to delete a license pool with a max count of ${maxLicenses}, effective between ${startDate} and ${endDate}.`
    },
    bulkDeleteMessageTemplate: records => {
      const totalSeats = records.reduce((sum, record) => {
        const seats =
          record["org_view_licenses.maxLicenses"] || record.poolCount || 0
        return sum + seats
      }, 0)
      return `You are about to delete ${records.length} license pools with a total of ${totalSeats} seats.`
    }
  }
}

export const LICENSE_ASSIGN: TableData = {
  columns: [], // Uses students columns from tables.ts
  displayedProperties: [
    "org_view_students.studentFullname",
    "org_view_students.hasActiveLicense",
    "org_view_students.classesCount",
    "org_view_students.email",
    "org_view_students.studentUserName"
  ],
  requestParams: {
    dimensions: [
      "org_view_students.studentId",
      "org_view_students.studentFirstName",
      "org_view_students.studentFullname",
      "org_view_students.studentLastName",
      "org_view_students.grade",
      "org_view_students.schoolName",
      "org_view_students.schoolId",
      "org_view_students.districtName",
      "org_view_students.districtId",
      "org_view_students.hasActiveLicense",
      "org_view_students.licenseExpiryDate",
      "org_view_students.licenseOrgType",
      "org_view_students.licenseOrgId",
      "org_view_students.licenseOrgName",
      "org_view_students.classesCount",
      "org_view_students.teacherName",
      "org_view_students.email",
      "org_view_students.studentUserName"
    ],
    measures: []
  },
  requestFilterMap: {
    state: "org_view_students.state",
    district: "org_view_students.districtId",
    school: "org_view_students.schoolId",
    teacher: "org_view_students.teacherId",
    class: "org_view_students.classId",
    student: "org_view_students.studentId",
    "user-status": "org_view_students.isActive",
    "license-status": "org_view_students.hasActiveLicense"
  },
  searchRequestParams: [
    "org_view_students.studentFullname",
    "org_view_students.email"
  ],
  tableOptions: {
    entityLabel: getWorkkeysReplaceTerm("student", true),
    searchPlaceholder: getWorkkeysReplaceTerm("students", true),
    caption: "List of License Assignments"
  }
}
